/** Help Center — same base URL used elsewhere on the marketing site */
export const HELP_CENTER_URL = 'https://entegy.help'

/** Solutions mega-menu: subsection heading + internal links */
export const solutionsMenu = [
  {
    heading: 'Sectors',
    links: [
      { label: 'Agencies & PCO', to: '/solutions/sectors/agencies-pco' },
      { label: 'Government', to: '/solutions/sectors/government' },
      { label: 'Corporations', to: '/solutions/sectors/corporations' },
      { label: 'Associations', to: '/solutions/sectors/associations' }
    ]
  },
  {
    heading: 'Type',
    links: [
      { label: 'Tradeshows & Exhibitions', to: '/solutions/type/tradeshows-exhibitions' },
      { label: 'Conferences & Seminars', to: '/solutions/type/conferences-seminars' },
      { label: 'Corporate Events', to: '/solutions/type/corporate-events' }
    ]
  },
  {
    heading: 'Outcomes',
    links: [
      { label: 'Data & Security', to: '/solutions/outcomes/data-security' },
      { label: 'Sponsorship', to: '/solutions/outcomes/sponsorship' },
      { label: 'Attendee Experience', to: '/solutions/outcomes/attendee-experience' }
    ]
  }
]

/** Resources dropdown */
export const resourcesMenu = [
  { label: 'News & Updates', to: '/news', external: false },
  { label: 'Help Center', href: HELP_CENTER_URL, external: true },
  { label: 'Case Studies', to: '/case-studies', external: false },
  { label: 'About entegy', to: '/about', external: false }
]
